import React from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";

import { setAndPrepareStateParam } from "../../helpers/URLHelper";
import { setPreferenceDetails } from "../../actions/preferencesActions";
import { setFeedbackDetails } from "../../actions/userDataActions";

import StandaloneMain from "./StandaloneMain";
import { withBaseContainer } from "../BaseContainer";
import BCLLoading from "../common/Loading/BCLLoading";
import { PRODUCT_TYPE } from "../../constants/common";

class StandaloneContainer extends React.Component {
  componentDidMount() {
    const {location} = this.props;
    let queryParams = setAndPrepareStateParam(location, true);
    if (Object.keys(queryParams).length > 0) {
      this.props.setFeedbackDetails(queryParams);
      if (queryParams && queryParams.tabType) {
        this.props.setPreferenceDetails(queryParams);
      }
    }
  }

  render() {
    return (
      <React.Suspense fallback={<BCLLoading />}>
        <Route component={StandaloneMain} />
      </React.Suspense>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setFeedbackDetails: feedbackDetails => dispatch(setFeedbackDetails(feedbackDetails)),
    setPreferenceDetails: preferenceDetails => dispatch(setPreferenceDetails(preferenceDetails))
  };
};

export default withBaseContainer(connect(null, mapDispatchToProps)(StandaloneContainer), PRODUCT_TYPE.WEB);
